import { Component, EventEmitter, Input, Output } from '@angular/core';
import {ListViewModel} from "../../shared/models/ui/list-view.model";
import {ButtonResponse} from "../util/ButtonResponse";

@Component({
    selector: 'bergh-list-view',
    templateUrl: './list-view.component.html',
    styleUrls: ['./list-view.component.scss'],
    standalone: false
})
export class ListViewComponent {

  @Input() data: ListViewModel;

  @Output() primaryButtonResponse: EventEmitter<ButtonResponse> = new EventEmitter();

  @Output() secondaryButtonResponse: EventEmitter<ButtonResponse> = new EventEmitter();

  constructor() { }

  setStyle(header: any, value: string) {
    if (typeof header.style === 'function'){
      return header.style(value);
    }
    return '';
  }
}
